const stripTextAfterDelimiters = (str) => {
  const delimiters = ['/:', '/{{', '/[:', '.'];
  for (let i = str?.length - 1; i >= 0; i--) {
    for (const delimiter of delimiters) {
      if (str?.substring(i - delimiter.length + 1, i + 1) === delimiter) {
        return str?.substring(0, i + 1);
      }
    }
  }
  return str;
};

const getFloatingPaneXOffset = (input) => {
  if (!input) {
    return null;
  }
  // Create a dummy span element
  const dummySpan = document.createElement('span');
  document.body.appendChild(dummySpan);

  // Copy the relevant styles from the input to the dummy span
  const inputStyle = window.getComputedStyle(input);
  dummySpan.style.fontSize = inputStyle.fontSize;
  dummySpan.style.fontFamily = inputStyle.fontFamily;
  dummySpan.style.letterSpacing = inputStyle.letterSpacing;
  dummySpan.style.whiteSpace = 'pre'; // Preserve spaces and tabs

  // Set the text content of the dummy span
  const cursorPosition = input.selectionStart;
  const inputValue = input.value;

  dummySpan.textContent = stripTextAfterDelimiters(inputValue?.substring(0, cursorPosition));

  // Measure the width of the dummy span
  const width = dummySpan.offsetWidth;

  // Clean up by removing the dummy span
  document.body.removeChild(dummySpan);

  return width > 8 ? width - 8 : width;
};

export default getFloatingPaneXOffset;
